export default __webpack_public_path__ + "static/media/match-02.452bb818.mp4";